var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTnkr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.002,
    height: 29.657,
    viewBox: "0 0 31.002 29.657",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.746,
    y1: 0.652,
    x2: 0.187,
    y2: 0.268,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#30bcd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ca28cc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-400.401 -44.171)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.112,330.712l2.75-.351,1.559,2.794-1.745,1.973a13.1,13.1,0,0,1,.5,1.861l2.535.916-.048,3.2-2.5.837a13.271,13.271,0,0,1-.5,1.857l1.74,2.064-1.641,2.748-2.58-.525a13.08,13.08,0,0,1-1.366,1.359l.474,2.654-2.795,1.559-1.319-1.167v-5.055a9.412,9.412,0,0,0,2.237-14.048l2.7-2.675Zm-17.2,2.781a9.412,9.412,0,0,0,2.325,13.942v4.974l-1.453,1.224-2.748-1.641.524-2.579a13.072,13.072,0,0,1-1.359-1.365l-2.655.474-1.559-2.795,1.745-1.973a13.086,13.086,0,0,1-.5-1.862l-2.535-.916.047-3.2,2.5-.837a13.238,13.238,0,0,1,.5-1.857l-1.739-2.064,1.64-2.748,2.562.521Z",
    transform: "translate(223.697 -279.828)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.225,294.031l2.795-1.559,1.972,1.745a13.071,13.071,0,0,1,1.862-.5l.916-2.535,3.2.047.836,2.5a13.3,13.3,0,0,1,1.857.5l2.063-1.739,2.747,1.641-.524,2.579q.284.245.554.509l-2.678,2.678a9.462,9.462,0,0,0-1.474-1.158l-1.561-.994v9.391l-1.742,1.006-1.742,1.006-1.742-1.006-1.742-1.006v-9.391l-1.561.994A9.466,9.466,0,0,0,254.689,300l-2.677-2.677q.33-.327.687-.634Z",
    transform: "translate(191.645 -247.015)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTnkr);
export default __webpack_public_path__ + "static/media/TNKR.d4e514d78132e0e9de76da35306e92e7.svg";
export { ForwardRef as ReactComponent };